import { NgModule } from "@angular/core";
import { TextboxFormComponent } from './textbox-form/textbox-form.component';
import { DynamicTextboxComponent } from './dynamic-textbox.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TextboxDesignComponent } from './textbox-design/textbox-design.component';
import { TextboxResultComponent } from './textbox-result/textbox-result.component';
import { MaterialModule } from '../../material.module';
import { KendoModule } from '../kendo.module';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';

@NgModule({
    declarations: [
        TextboxResultComponent,
        TextboxDesignComponent,
        TextboxFormComponent, DynamicTextboxComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        AbwConditionalFormatingModule
    ],
    entryComponents: [
        DynamicTextboxComponent
    ]
})
export class TextboxModule {}